export default __webpack_public_path__ + "static/media/Brush.fda2491d.svg";